<!--
 * @Description: 
 * @Date: 2020-11-14 17:08:35
-->
<template>
  <div class="living">
    <template v-if="show">
      <!-- 问卷限制 -->
      <living-survey v-if="showSurvey"></living-survey>
      <template v-else>
        <living-video></living-video>
        <living-title></living-title>
        <living-rela style="border-top:.09rem solid #EDEDED"></living-rela>
        <living-tabs></living-tabs>
        <living-content></living-content>
        <living-cover></living-cover>
        <living-gift :currentUserGift="gift"></living-gift>
      </template>
    </template>
  </div>
</template>
<script>
import LivingGift from './components/livingGift';
import LivingRela from './components/livingRela';
import LivingTabs from './components/livingTabs';
import LivingContent from './components/livingContent';
import LivingSurvey from './components/livingSurvey';
import LivingCover from './components/livingCover';
import LivingVideo from './components/livingVideo';
import LivingTitle from './components/livingTitle';

import { mapState } from 'vuex';
import { storageUserInfo, getStorage } from '@/utils/storage';

import { shareCallback, getChannelById } from '@/api/ajax.js';

export default {
  name: 'Living',
  provide() {
    return {
      livingStore: this.livingStore
    };
  },
  data() {
    return {
      show: false,
      saTimer: null, // 神策定时上报
      gift: {} // 礼物
    };
  },
  components: {
    LivingGift,
    LivingTabs,
    LivingContent,
    LivingSurvey,
    LivingRela,
    LivingCover,
    LivingVideo,
    LivingTitle
  },

  computed: {
    ...mapState({
      livingStore: state => state.living,
      wxUserInfo: state => state.wxUserInfo
    }),
    livingDetail() {
      return this.livingStore.detail;
    },
    livingConf() {
      return this.livingStore.livingConf;
    },
    livingStatus() {
      return this.livingStore.livingStatus;
    },

    isAdmin() {
      return this.$route.query.platform === 'admin';
    },
    showSurvey() {
      if (this.isAdmin) {
        // 预览模式
        return false;
      }
      const { checkInfo, isSubmitCheck } = this.livingStore;
      return Object.keys(checkInfo).length > 0 && !isSubmitCheck;
    }
  },
  watch: {
    livingStatus: {
      immediate: true,
      handler(v) {
        // 跳转到录播
        if (v === 6) {
          this.$router.replace({
            name: 'courseDetail',
            params: { id: this.$route.params.id }
          });
        }
      }
    },
    $route: {
      handler() {
        this.init();
      }
    }
  },
  methods: {
    // 创建socket链接与消息接收处理
    registerSocket() {
      // 解析socket返回数据
      const getMessageValue = data => {
        let index = data.indexOf(':');
        let prefix = data.substr(0, index);
        let value = null;
        try {
          value = JSON.parse(data.substr(index + 1));
        } catch (e) {}
        return {
          prefix,
          value
        };
      };
      window.dmsocket = new WebSocket(
        `${this.$config.webSocketPath}/ws?channel=yxvzb_${this.livingDetail.id}`
      );
      window.dmsocket.onopen = () => {
        window.dmsocket.onmessage = event => {
          let data = event.data;
          let { prefix, value } = getMessageValue(data);
          // 初始化并上报当前链接
          if (prefix == 'INFO') {
            // type 3 为人数登记
            window.dmsocket.send(JSON.stringify({ type: 3 }));
          }
          // 接收礼物
          if (prefix == 'PRIZE') {
            this.gift = value;
          }
          // 实时人数与总人数
          if (prefix == 'PEOPLE') {
            const { real, total } = value;
            this.$store.commit('living/SET_COMMON', {
              field: 'realUsers',
              value: real
            });
            this.$store.commit('living/SET_COMMON', {
              field: 'totalUsers',
              value: total
            });
          }
        };
      };
    },
    async init() {
      try {
        window.dmsocket.close();
      } catch (e) {}
      await this.$store.dispatch('living/init');
      let {
        courseName,
        videoPicUrl,
        courseContent,
        id,
        coverPic,
        shareUrl,
        editorName
      } = this.livingDetail;
      if (!this.show) {
        setTimeout(() => {
          this.show = true;
        }, 100);
      }
      if (!this.isAdmin && id) {
        this.registerSocket();
        document.title = courseName;
        // 事件上报
        this.$sa.re_contentview({
          type: '直播', // 直播，录播，资讯，病例
          name: courseName, // 内容名字
          contentid: id // 内容id
        });

        // 注册分享
        // this.$wxShare({
        //   title: courseName,
        //   imgUrl: videoPicUrl,
        //   desc: '',
        //   callback: () => {
        //     this.$sa.re_interaction({
        //       type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        //       contentype: '直播', // 互动主体 直播，录播，资讯，病例，站内信，论坛, 调研
        //       contentid: id, // 内容id
        //       contentname: courseName
        //       //  source_user_id: this.$route.query.source_user_id || "", // 邀请人ID 全局使用
        //       //  projectId: this.$route.query.projectId || ""
        //     });
        //   }
        // });

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              //您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'live',
                target: id,
                client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: 5, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: id, // 内容id
              author: editorName || '', //讲师/作者
              contentname: courseName,
              zone_name: this.$route.query.source_user_id
                ? ''
                : this.zone_name || '', // 来源专区
              zone_id: this.$route.query.source_user_id
                ? ''
                : this.$route.query.zone_id || '', // 来源专区
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };

        let isShequn = this.$route.query.shequn;
        let isShare = this.$route.query.shareFlag;
        let sourceFrom = this.$route.query.sourceFrom;

        let shareUrl = this.$api.infoWxShareUrl();
        if (isShequn) {
          shareUrl = shareUrl.split('?')[0];
        }
        if (!isShare) {
          let { zone_id, source_user_id } = this.$route.query;
          if (zone_id && !source_user_id) {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}source_user_id=${this.wxUserInfo.shenceId}&shareFlag=true`;
          } else {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}shareFlag=true`;
          }
        }
        if (this.$route.query.zone_id) {
          getChannelById({
            channelId: this.$route.query.zone_id
          }).then(res => {
            this.zone_name = res.data.data;
            this.$wxShareInfo(
              courseName,
              courseName,
              coverPic,
              location.href,
              shareUrl,
              shareCallBackFunc
            );
          });
        } else {
          this.$wxShare({
            target: shareUrl,
            title: courseName,
            imgUrl: videoPicUrl,
            desc: courseName,
            callback: shareCallBackFunc
          });
        }
      }
    }
  },
  async created() {
    this.init();
    // 设置关联直播
    window.setCourseRela = relas => {
      this.$store.commit('living/SET_COMMON', {
        field: 'rela',
        value: relas
      });
    };

    // 设置直播详情
    window.setLivingDetail = detail => {
      this.$store.commit('living/SET_COMMON', {
        field: 'detail',
        value: { ...this.livingDetail, ...detail }
      });
    };

    // 设置直播配置
    window.setLivingConfig = config => {
      this.$store.commit('living/SET_COMMON', {
        field: 'livingConf',
        value: { ...this.livingConf, ...config }
      });
    };
  },
  beforeDestroy() {
    this.saTimer && clearInterval(this.saTimer);
    try {
      window.dmsocket.close();
    } catch (e) {}
  }
};
</script>
<style lang="less" scoped></style>
